var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Header", [
        _c("div", { staticClass: "headertitle" }, [
          _c(
            "a",
            {
              staticClass: "headertitle-home",
              attrs: { href: "/", title: "Home", "aria-label": "Home" },
            },
            [
              _c("i", {
                staticClass: "fas fa-home",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          ),
          _vm._v(" "),
          _c("a", { attrs: { href: "/" } }, [
            _vm._v(
              "\n                    Prize Designs for Modern Furniture+Lighting"
            ),
            _c("span", { staticClass: "copyright" }, [_vm._v("®")]),
            _vm._v("\n                    AWARD\n                "),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 15 } },
        [
          _c("el-col", { attrs: { xs: 24, sm: 6, lg: 4 } }, [
            _vm.$auth.user()
              ? _c(
                  "div",
                  { staticClass: "side-menu-frame" },
                  [
                    _c("router-link", { attrs: { to: _vm.accountLink } }, [
                      _vm._v(
                        "\n                        Account\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.reloadPageWhenRouteTheSame()
                          },
                        },
                      },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: { to: { name: "furniture-lighting-form" } },
                          },
                          [
                            _vm._v(
                              "\n                            New Submission\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("router-link", { attrs: { to: _vm.submissionLink } }, [
                      _vm._v(
                        "\n                        My Submissions\n                    "
                      ),
                    ]),
                  ],
                  1
                )
              : _c("div", [_vm._v("\n \n                ")]),
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 18, lg: 12 } },
            [_c("router-view")],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("Footer", [
        _c("div", { staticClass: "footerlogo-caption" }, [
          _vm._v(
            "\n                Prize Designs for Modern Furniture + Lighting® is a registered\n                trademark of Metropolitan Arts Press Ltd. copyright © 2022 -2026\n                all rights reserved.\n            "
          ),
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: "/images/furniture_lighting_award_logo.svg" },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }